module.exports = __webpack_public_path__ + "static/003-83b9077d112ce5c8c315e31b5e671c02.png";